import React from 'react';
import SalesExecutiveDashboard from '../../components/SalesExecutive/Dashboard';

const SalesExecutiveDashboardPage: React.FC = () => {
  return <SalesExecutiveDashboard />;
};

export default SalesExecutiveDashboardPage; 